import React from "react";
import GroupReportStyle from "./style";
import DevelopmentImg from "../../../../assets/Icons/development-img.png";
import { Row, Table } from "antd";
import { useSelector } from "react-redux";
import COLORS from "../../../../common/Colors";
import styled from "styled-components";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const GroupReport = () => {
  const addGroupData = useSelector(
    (state) => state.systemTracking.addGroupData
  );
  const CourserOverviewData = [
    {
      label: "Completion rate",
      value: "0.0%",
    },
    {
      label: "Completed courses",
      value: 0,
    },
    {
      label: "Courses in progress",
      value: 0,
    },
    {
      label: "Courses not passed",
      value: 0,
    },
    {
      label: "Courses not started",
      value: 0,
    },
    {
      label: "Training time",
      value: "0h 0m",
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "group",
      key: "group",
    },
    {
      title: "Assigned users",
      dataIndex: "assignedUsers",
      key: "assignedUsers",
    },
    {
      title: "Completion rate",
      dataIndex: "completionRate",
      key: "completionRate",
    },
  ];

  return (
    <>
      <GroupReportStyle>
        <div className="user-title-container users-menu-filter-container">
          <h1 className="user-menu-title">Group Reports</h1>
        </div>

        <div className="course-overview-data-box">
          {CourserOverviewData.map((item, index) => {
            return (
              <div key={index}>
                <p className="overview-value">{item.value}</p>
                <p className="overview-label">{item.label}</p>
              </div>
            );
          })}
        </div>

        {addGroupData.length > 0 ? (
          <>
            <StyledTable
              dataSource={addGroupData}
              columns={columns}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="key"
              id="Table"
              // onChange={onChangeSortedTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => {
                    // handleClickData(record);
                  },
                };
              }}
            />
          </>
        ) : (
          <>
            <Row className="yet-designed-pages">
              <img
                src={DevelopmentImg}
                alt={DevelopmentImg}
                className="yet-designed-pages-image"
              />
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no Groups yet!
                </p>
              </div>
            </Row>
          </>
        )}
      </GroupReportStyle>
    </>
  );
};

export default GroupReport;
